module.exports = __webpack_public_path__ + "static/img/Cloud_Check.5000bff7.png";